
    <div class="d-flex d-flex-gap">
      <span
        [class.text-success]="value > 0"
        [class.text-danger]="value < 0"
        [class.font-weight-bold]="isGroup$ | async"
      >
        {{ '%.3f %%' | sprintf : [value] }}
      </span>

      <fieldmagic-icon
        *ngIf="value !== 0"
        [icon]="[
          {
            icon: value > 0 ? 'caret-up' : 'caret-down',
            klass: value > 0 ? 'text-success' : 'text-danger'
          }
        ]"
      >
      </fieldmagic-icon>
    </div>
  